var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"CooperateCompany"},[_c('div',{staticClass:"title"},[_vm._v("你知道的企业都在用")]),_vm._v(" "),_c('ScrollLogo')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }